export const smbOnboarding = {
  title: "Üzleti oldal létrehozása",
  navigation: {
    back: "Vissza",
    next: "Tovább",
    finish: "Befejezés"
  },
  toast: {
    name_required: "Név kötelező",
    name_required_desc: "Kérjük, add meg az üzleted nevét a folytatás előtt.",
    thank_you: "Köszönjük!",
    thank_you_desc: "Az onboarding információkat sikeresen elküldtük.",
    saved: "Profil mentve",
    saved_desc: "Az üzleti profilod sikeresen létrehozva.",
    error: "Hiba",
    error_desc: "Hiba történt a profilod mentése közben. Kérjük, próbáld újra."
  },
  steps: {
    business_info: {
      title: "Üzleti információk",
      description: "Add meg az üzleted alapvető információit.",
      business_name: "Üzlet neve",
      business_name_placeholder: "pl. Szép Frizura Fodrászat",
      business_category: "Üzlet típusa",
      business_category_placeholder: "Válaszd ki az üzlet típusát",
      address: "Cím",
      address_placeholder: "1234 Budapest, Példa utca 12.",
      phone: "Telefonszám",
      phone_placeholder: "+36 20 123 4567",
      email: "E-mail cím",
      email_placeholder: "info@uzletem.hu",
      website: "Weboldal (opcionális)",
      website_placeholder: "https://www.uzletem.hu",
      logo: "Logó",
      upload_logo: "Logó feltöltése",
      logo_help: "Kattints a képre a feltöltéshez (Min. 500x500 pixel ajánlott)",
      bio: "Üzlet leírása",
      bio_placeholder: "Mesélj az üzletedről, milyen szolgáltatásokat kínálsz, mi teszi különlegessé...",
      categories: {
        salon: "Fodrászat",
        barbershop: "Borbélyszalon",
        beauty_salon: "Szépségszalon",
        nail_salon: "Körömsalon",
        spa: "Spa / Wellness",
        massage: "Masszázs",
        yoga_studio: "Yoga stúdió",
        fitness_center: "Fitnesz központ",
        pilates_studio: "Pilates stúdió",
        dance_studio: "Tánc stúdió",
        personal_training: "Személyi edzés",
        nutritionist: "Táplálkozási tanácsadás",
        physiotherapy: "Fizikoterápia",
        dental: "Fogorvosi rendelő",
        veterinary: "Állatorvosi rendelő",
        cafe: "Kávézó",
        restaurant: "Étterem",
        bakery: "Pékség",
        photography: "Fotóstúdió",
        tutoring: "Magánoktatás",
        music_school: "Zeneiskola",
        art_studio: "Művészeti stúdió",
        consulting: "Tanácsadás",
        accounting: "Könyvelés",
        legal: "Jogi szolgáltatás",
        real_estate: "Ingatlan",
        cleaning: "Takarítás",
        repair: "Javítás / szerelés",
        pet_grooming: "Állatkozmetika",
        other: "Egyéb"
      },
      tip_title: "Tipp",
      tip_description: "Az alapvető információk segítenek az ügyfeleidnek megtalálni téged és kapcsolatba lépni veled. Ügyelj arra, hogy pontos és naprakész legyen minden adat."
    },
    services: {
      title: "Szolgáltatások",
      description: "Add meg, milyen szolgáltatásokat kínálsz az ügyfeleidnek.",
      add_service: "Szolgáltatás hozzáadása",
      service_name: "Szolgáltatás neve",
      service_name_placeholder: "pl. Női hajvágás",
      service_description: "Leírás",
      service_description_placeholder: "Rövid leírás a szolgáltatásról",
      service_price: "Ár (Ft)",
      service_price_placeholder: "5000",
      service_duration: "Időtartam (perc)",
      service_duration_placeholder: "60",
      no_services: "Még nincs szolgáltatás hozzáadva",
      services_added: "szolgáltatás hozzáadva",
      remove_service: "Törlés",
      tip_title: "Tipp",
      tip_description: "Adj meg világos árakat és időtartamokat. Ez segít az ügyfeleidnek dönteni és időpontot foglalni."
    },
    opening_hours: {
      title: "Nyitvatartás",
      description: "Add meg az üzleted nyitvatartási idejét.",
      day_closed: "Zárva",
      day_open: "Nyitva",
      from: "Mettől",
      to: "Meddig",
      add_break: "Szünet hozzáadása",
      remove_break: "Szünet törlése",
      break_from: "Szünet kezdete",
      break_to: "Szünet vége",
      days: {
        monday: "Hétfő",
        tuesday: "Kedd",
        wednesday: "Szerda",
        thursday: "Csütörtök",
        friday: "Péntek",
        saturday: "Szombat",
        sunday: "Vasárnap"
      },
      tip_title: "Tipp",
      tip_description: "Pontos nyitvatartási idő segít az ügyfeleidnek tervezni. Ha van ebédszünet vagy egyéb zárva tartás, azt is add meg."
    },
    team: {
      title: "Csapat (opcionális)",
      description: "Add meg a csapattagjaid, akik az üzletedben dolgoznak.",
      add_member: "Csapattag hozzáadása",
      member_name: "Név",
      member_name_placeholder: "pl. Kiss Anna",
      member_role: "Pozíció",
      member_role_placeholder: "pl. Fodrász",
      member_bio: "Bemutatkozás (opcionális)",
      member_bio_placeholder: "Rövid bemutatkozás a csapattagról",
      member_photo: "Fotó",
      upload_photo: "Fotó feltöltése",
      no_members: "Még nincs csapattag hozzáadva",
      members_added: "csapattag hozzáadva",
      remove_member: "Törlés",
      tip_title: "Tipp",
      tip_description: "A csapat bemutatása személyesebbé teszi az üzletedet és növeli a bizalmat az ügyfelek felé. Ez a lépés opcionális, később is hozzáadhatsz csapattagokat."
    },
    design: {
      title: "Megjelenés, arculat",
      description: "Válaszd ki, milyen megjelenési stílust szeretnél az oldaladon.",
      tip_title: "Profi tipp",
      tip_description: "A jó design növeli a bizalmat és segít kitűnni a versenytársaid közül. Válassz olyan stílust, ami tükrözi az üzleted személyiségét."
    }
  }
};